import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";
import BBSEditor from "./BBSEditor";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterFaq({ editMode, faq, onRegisterFaq }: { editMode: string; faq?: Types.FaqDto; onRegisterFaq?: () => void }) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [faqQuestion, setFaqQuestion] = useState("");
    const [faqAnswer, setFaqAnswer] = useState("");
    const [faqOrder, setFaqOrder] = useState("");
    const [inputs, setInputs] = useState<Types.FaqDto>();
    const [content, setContent] = useState<string>("");

    const requestAxiosAddFAQ = async (data: Types.FaqDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.FAQ_URL, data);

        return response.data;
    };

    const { loading: loadingAddFaq, error: errorAddFaq, data: resultAddFaq, execute: requestAddFaq } = useAsyncAxios(requestAxiosAddFAQ);

    useEffect(() => {
        if (faq === undefined) return;

        form.setFieldsValue(faq);
    }, [faq]);

    useEffect(() => {
        if (resultAddFaq === null) return;

        if (onRegisterFaq) onRegisterFaq();

        alert.setAlert(AlertType.SUCCESS, "FAQ 추가 성공", "FAQ 추가를 완료하였습니다.");
    }, [resultAddFaq]);

    useEffect(() => {
        if (errorAddFaq === null) return;

        console.log("errorFaq", errorAddFaq);
        alert.setAlert(errorAddFaq.response.data.code, "FAQ 추가 실패", errorAddFaq.response.data.message);
    }, [errorAddFaq]);

    const requestAxiosUpdateFaq = async (data: Types.FaqDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.FAQ_URL + "/" + data.faqId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateFaq,
        error: errorUpdateFaq,
        data: resultUpdateFaq,
        execute: requestUpdateFaq,
    } = useAsyncAxios(requestAxiosUpdateFaq);

    useEffect(() => {
        if (resultUpdateFaq === null) return;

        if (onRegisterFaq) onRegisterFaq();

        alert.setAlert(AlertType.SUCCESS, "FAQ 수정 성공", "FAQ 수정을 완료하였습니다.");
    }, [resultUpdateFaq]);

    useEffect(() => {
        if (errorUpdateFaq === null) return;

        console.log("errorUpdateFaq", errorUpdateFaq);
        alert.setAlert(errorUpdateFaq.response.data.code, "FAQ 수정 실패", errorUpdateFaq.response.data.message);
    }, [errorUpdateFaq]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.FaqDto = {
            ...values,
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddFaq(data);
        else if (editMode === "update") requestUpdateFaq(data);
    };

    const onChange = (contents: string) => {
        setContent(contents);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="faqQuestion"
                                label="FAQ 질문"
                                rules={[
                                    {
                                        required: true,
                                        message: "질문을 입력해 주세요.",
                                    },
                                ]}
                            >
                                {editMode === "add" ? <Input placeholder={String.title} /> : <Input value={inputs?.faqQuestion} />}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="faqId" label="FAQ ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="faqOrder" label="FAQ 순서">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="faqAnswer"
                                label="FAQ 답변"
                                rules={[
                                    {
                                        required: true,
                                        message: "답변을 입력해 주세요.",
                                    },
                                ]}
                            >
                                {editMode === "add" ? (
                                    <BBSEditor onChange={onChange} hasAttachFiles={false} />
                                ) : (
                                    <BBSEditor onChange={onChange} value={inputs?.faqAnswer} />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterFaq;
